$(function() {
    $(".video-pop-wrapper").on("click", ".close-js, .tw-mask", function(e) {
        $(this).closest(".video-pop-wrapper").fadeOut();
        var videoElement = $(this).closest(".video-pop-wrapper").find("video")[0];
        videoElement && videoElement.pause();
        var iframeElement = $(this).closest(".video-pop-wrapper").find("iframe")[0];
        if (iframeElement) {
            var iframeSrc = iframeElement.src;
            iframeElement.src = iframeSrc
        }
    }),
    $(".video-pop-js").click(function(e) {
        const popId = $(this).attr("pop-id")
          , videoWrap = $('.video-pop-wrapper[pop-id="' + popId + '"]');
        e.preventDefault(),
        videoWrap.fadeIn();
        const videoElement = videoWrap.find("video")[0];
        videoElement && videoElement.paused && videoElement.play();
        const iframeElement = videoWrap.find("iframe")[0];
        if (iframeElement) {
            const iframeSrc = iframeElement.src;
            iframeElement.src = iframeSrc
        }
    })
});
//# sourceMappingURL=/cdn/shop/t/25/assets/featured-product-2_0.js.map?v=148255856498347359161727171985
